import { h, Component } from 'preact';
import Screening from 'components/bolt/showtimes/screening';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import { getFormatImage } from 'utils/bolt/screeningAttributes';
import DateScroller from 'components/bolt/showtimes/dateScroller';
import ShowtimesMessage from 'components/bolt/showtimes/showtimesMessage';
import Geo from 'models/Geo';

import { joinClasses, accessNested } from 'utils/utils';
import ScreeningDetails from 'components/bolt/showtimes/screeningDetails';
import { generateLanguageLabel } from 'utils/bolt/screeningAttributes';

import s from 'components/bolt/showtimes/theater.sss';

export default class Theater extends Component {

	constructor(props) {
		super(props);
		this.renderScreeningsCategory = this.renderScreeningsCategory.bind(this);
		this.getDetails = this.getDetails.bind(this);
		this.getHeroDetails = this.getHeroDetails.bind(this);
	}

	getHeroDetails(format, category, heroOption) {
		const { sharedImageRoot, logoShade } = this.props;
		let heroName;
		let heroImage;

		switch (heroOption) {
			case 'language':
				heroName = category?.langLabel;
				break;
			case 'movieId':
				heroName = category?.movieTitle;
				break;
			case 'format':
				heroImage = getFormatImage(format, category, this.props.theater, sharedImageRoot, logoShade);
				heroName = format;
				// if (category?.audioDetails) {
				// 	heroName += ' (' + category.audioDetails + ')';
				// }
				break;
		}

		return { heroName, heroImage };
	}

	getDetails(category) {
		const { showtimesAppData, copy } = this.props;
		const heroOption = showtimesAppData?.screeningCategories?.hero || 'format';
		const { format, langLabel, attributes, movieTitle } = category;

		const details = [];
		const exclusions = this.props.showtimesAppData?.screeningCategories?.exclusions || {};

		if (movieTitle && heroOption !== 'movieId' && !exclusions.movieId) {
			details.push(movieTitle?.toUpperCase());
		}
		if (format && heroOption !== 'format') {
			details.push(format);
		}
		if (langLabel && heroOption !== 'language' && !exclusions.language) {
			details.push(langLabel);
		}

		if (attributes?.length > 0) {
			const attributesCopy = copy?.baseCopy?.filters?.attributes || {};
			attributes.forEach((attr) => {
				details.push(attributesCopy[attr] || attr);
			});
		}
		return details;
	}

	handleScreeningCategoryLogo(formatOrCategory) {
		let format = null;
		let category = null;
		if (typeof formatOrCategory === 'object') {
			format = formatOrCategory.format;
			category = formatOrCategory;
		} else {
			format = formatOrCategory;
			category = null;
		}
		const { showtimesAppData } = this.props;
		const heroOption = showtimesAppData?.screeningCategories?.hero || 'format';

		const { heroName, heroImage } = this.getHeroDetails(format, category, heroOption);
		const details = category ? this.getDetails(category) : null;

		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');
		const isRTL = fontStyles.textDirection === 'rtl';

		return (
			<div class={joinClasses(s.label, fontStyles.showtimesTheaterFormats, isRTL && s.rtlLabel)}>
				{heroImage ? (<img class={s.logo} src={heroImage} />) : heroName} {details}
			</div>
		);
	}

	useLocalOrIntl(showtimesAppData, geoFromIP, theaterCountry) {
		if (showtimesAppData.theaterLocalisation !== 'area') {
			return showtimesAppData.theaterLocalisation || 'local';
		}

		if (geoFromIP && geoFromIP.countryCode === theaterCountry) {
			return 'local';
		}

		return 'intl';
	}

	renderScreeningsCategory(category, index) {

		const { theater, showtimesAppData, mode, showtimesMode, trackConversion, divideScreeningsByAttributes } = this.props;
		const heroOption = showtimesAppData?.screeningCategories?.hero || 'format';

		const screeningCategoriesExclusions = this.props.showtimesAppData?.screeningCategories?.exclusions || {};

		const isHeroOnly = ['language', 'attributes', 'movieId']
			.filter(x => !screeningCategoriesExclusions[x])
			.length === 0;

		const hasScreeningsCategories = divideScreeningsByAttributes && !isHeroOnly;

		return (
			<div class={joinClasses(s.category, hasScreeningsCategories && s.divideScreeningsByAttributes)} key={category.name}>

				{showtimesMode === 'map' ?
					(
						this.handleScreeningCategoryLogo(category)
					) : (
						(!hasScreeningsCategories)
							? this.handleScreeningCategoryLogo(category)
							: (
								<ScreeningDetails
									heroOption={heroOption}
									getDetails={this.getDetails}
									getHeroDetails={this.getHeroDetails}
									category={category}
									sharedImageRoot={this.props.sharedImageRoot}
									logoShade={this.props.logoShade}
									copy={this.props.copy}
									index={index}
								/>
							)
					)
				}
				<div class={s.screenings}>
					{category.screenings.sort((a, b) => a.time.localeCompare(b.time)).map(screening => (
						<Screening
							screening={screening}
							theater={theater}
							showtimesAppData={showtimesAppData}
							mode={mode}
							trackConversion={trackConversion}
							isPreviewPanelScreening={this.props.mode === 'film'}
						/>
					))}
				</div>
			</div>
		);
	}

	renderLoadingState() {
		const { copy } = this.props;
		return (
			<div class={joinClasses(s.category, s.dummyCat)}>
				<div class={s.loadingContainer}>
					<div class={s.label}>{copy.baseCopy.$LOADING_SHOWTIMES || 'Loading showtimes'}</div>
					<div class={s.loadingIcon} />
				</div>
				<div class={s.screenings}>
					<div class={s.dummyScreening} />
					<div class={s.dummyScreening} />
					<div class={s.dummyScreening} />
					<div class={s.dummyScreening} />
				</div>
			</div>
		);
	}

	renderErrorState(extraClass) {
		const copy = this.props.copy;

		return (
			<ShowtimesMessage
				class={extraClass}
				message={copy.baseCopy.$ERROR_SHOWTIMES}
				cta={copy.baseCopy.$ERROR_SHOWTIMES_CTA}
				buttonCopy={copy.baseCopy.$REFRESH || 'Refresh'}
				buttonTrigger={() => Store.emit('SHOWTIMES_REFRESH')}
			/>
		);
	}

	renderEmptyState(extraClass) {
		const copy = this.props.copy;

		return (
			<ShowtimesMessage
				class={extraClass}
				message={copy.baseCopy.$NO_SHOWTIMES}
				cta={copy.baseCopy.$NO_SHOWTIMES_CTA}
				buttonCopy={copy.baseCopy.$FILTERS || 'Filters'}
				buttonTrigger={this.props.showFilterSelection}
			/>
		);
	}

	renderViewButtonState() {
		const { theater, mode, onExpandClick, isDesktopSize } = this.props;

		if (mode !== 'list' && typeof onExpandClick === 'function' && !isDesktopSize) {
			if (!theater || theater.loading) {
				return (
					<div>
						{mode !== 'expanded' ? (
							<div class={s.dummyButton} />
						) : (
							<div class={joinClasses(s.viewShowtimesContainer, s.dummyViewShowtimesContainer)}>
								<div class={s.dummyLabel}>{this.props.copy.baseCopy.$LOADING_SHOWTIMES || 'Loading showtimes'}</div>
								<div class={s.loadingIcon} />
							</div>
						)}
					</div>
				);
			}
			if (theater.error) {
				return this.renderErrorState(s.mobileSeparator);
			}
			if (!theater.screenings || !theater.screenings.length) {
				return this.renderEmptyState(s.mobileSeparator);
			}

			return (
				<div class={s.viewShowtimesContainer}>
					<Button type="primary" class={s.viewShowtimes} trigger={onExpandClick}>{this.props.copy.baseCopy.$VIEW_SHOWTIMES || 'View Showtimes'}</Button>
				</div>
			);
		}
	}

	renderScreenings() {
		let screenings = this.props.theater.screenings || [];

		let screeningsByCategory = screenings.reduce((obj, screening) => {
			// const { divideScreeningsByAttributes } = this.props;

			const screeningCategoriesExclusions = this.props.showtimesAppData?.screeningCategories?.exclusions || {};
			const format = !screeningCategoriesExclusions.format ? (screening.format || '2D') : '';
			const langLabel = !screeningCategoriesExclusions.language ? (generateLanguageLabel(screening) || '') : '';
			const movieId = !screeningCategoriesExclusions.movieId ? screening.movieId : null;
			const audioDetails = !screeningCategoriesExclusions.audioDetails ? screening.audioDetails : null;

			const currentRegion = Store.get().client?.geo?.countryCode;
			const movieData = this.props.showtimesAppData?.movieData;

			const movieTitle =
				movieData?.[currentRegion]?.[movieId]?.title
				// 2. Thundr movieData Top Level override title
				||	movieData?.[movieId]?.title
				// 3. Title coming from API for this region
				||	screening.movie.regions.find(region => region.country === currentRegion)?.title
				// 4. Title coming from API for INTL region
				|| screening.movie.regions.find(region => region.country === 'INTL')?.title
				// 5. Last resort - the movie id itself
				|| movieId;

			let attributes = [];

			if (!screeningCategoriesExclusions.attributes) {
				attributes = (screening.attributes || []).filter(a => !screeningCategoriesExclusions[a]);
			}

			const attributesString = attributes.sort().join('');
			const compKey = [format, audioDetails, movieId, langLabel, attributesString].filter(e => e).join('~~');
			let category = compKey;
			if (!obj[category]) {
				obj[category] = {
					name: category,
					format,
					audioDetails,
					langLabel,
					attributes,
					screenings: [],
					movieTitle
				};
			}
			obj[category].screenings.push(screening);
			return obj;
		}, {});
		let categories = Object.values(screeningsByCategory).filter(cat => cat && cat.screenings.length).sort((a, b) => {
			return a.name.localeCompare(b.name);
		});

		return categories.map(this.renderScreeningsCategory);
	}

	renderVisualState() {
		const{ additionalText, additionalTextOnClick, theater, mode } = this.props;
		let error = theater.error;
		let empty = !theater.screenings || !theater.screenings.length;
		let expanded = mode === 'expanded';
		let nonReadyState = (theater.loading && mode === 'list') || error || empty;
		let viewState;

		if (theater.loading) {
			viewState = this.renderLoadingState();
		} else if (error) {
			viewState = this.renderErrorState();
		} else if (mode !== 'list' && empty) {
			viewState = this.renderEmptyState();
		} else {
			viewState = this.renderScreenings();
		}

		return (
			<div class={joinClasses(s.allScreenings, nonReadyState && s.separator, expanded && s.theaterExpanded)} key="screenings">
				{viewState}
				{additionalText && (
					<div
						class={joinClasses(s.additionalText, 'medium')}
						onClick={additionalTextOnClick}
					>
						{additionalText}
					</div>
				)}
				{((this.props.loading) && (this.props.theater && !this.props.theater.loading)) && (
					<div class={s.partialLoadingIcon} />
				)}
			</div>
		);
	}

	renderDateScroller() {
		const { displayedDates, mode, loading, theater } = this.props;
		if (this.props.displayedDates && mode === 'expanded' && !theater[loading]) {
			return (
				<div class={s.dateScrollerContainer} key="dateScrollerContainer">
					<DateScroller
						ref={e => this.$filterDate = e}
						appData={Store.get().appData}
						showtimesAppData={this.props.showtimesAppData}
						client={Store.get().client}
						displayedDates={displayedDates}
						onChange={this.props.onDateChange}
						hideInactive
						backAction={this.props.backAction}
						theaterDateScroller
						selectedTheater={this.props.selectedTheater}
						showtimesMode={this.props.showtimesMode}
						mapMode={this.props.mode}
					/>
				</div>
			);
		}
	}

	renderHeader() {
		const { theater, clientGeo, mode, onExpandClick, sharedImageRoot, logoShade, showtimesAppData, geoFromIP } = this.props;
		const theaterCountry = accessNested(theater, 'address.local.country', '').toLowerCase();
		const localOrIntl = this.useLocalOrIntl(showtimesAppData, geoFromIP, theaterCountry);
		const theaterName = accessNested(theater, `address.${localOrIntl}.name`) || theater.name;
		const theaterStreet = accessNested(theater, `address.${localOrIntl}.street`, '');
		const theaterCity = accessNested(theater, `address.${localOrIntl}.city`, '');
		const theaterGeo = new Geo({ lat: theater.lat, lon: theater.lon });
		const currentGeo = clientGeo && new Geo({ lat: clientGeo.lat, lon: clientGeo.lon });
		const distanceUnit = showtimesAppData.theaterDistanceUnit || 'km';
		const distance = theaterGeo.distanceFrom(currentGeo, distanceUnit, 1);
		const logo = accessNested(theater, 'chain.logo') || 'default.png';
		const logoLink = `${sharedImageRoot}/logos/${logoShade}/${logo}`;
		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});
		const strippedChainName = theater.chain && theater.chain.name.replace(/\..*/, '');
		const isRTL = fontStyles.textDirection === 'rtl';


		if (mode !== 'expanded' && typeof onExpandClick === 'function') {
			return (
				<Button class={s.button} trigger={onExpandClick} ariaLabel={accessibilityCopy.$EXPAND_CINEMA_ARIA}>
					<div ref={ref => this.header = ref} class={s.header}>
						<div class={joinClasses(s.icon, isRTL && s.rtlIcon)}>
							<img src={logoLink} alt={accessibilityCopy.$CINEMA_LOGO_ALT.replace('<chain>', strippedChainName)} />
						</div>
						<div class={s.details}>
							<div class={joinClasses(s.name, fontStyles.showtimesTheaterName)}>{theaterName}</div>
							<div class={joinClasses(s.location, isRTL && s.rtlLocation)}>
								<span class={joinClasses(s.distance, fontStyles.showtimesTheaterDistance)}>{distance + distanceUnit}</span>
								<span class={joinClasses(s.address, fontStyles.showtimesTheaterAddress)}>{`${theaterStreet}, ${theaterCity}`}</span>
							</div>
						</div>
						<div class={s.expand} />
					</div>
				</Button>
			);
		}

		return (
			<div class={s.header}>
				<div class={joinClasses(s.icon, isRTL && s.rtlIcon)}>
					<img src={logoLink} />
				</div>
				<div class={s.details}>
					<div class={joinClasses(s.name, fontStyles.showtimesTheaterName)}>{theater.name}</div>
					<div class={s.location}>
						<span class={joinClasses(s.distance, fontStyles.showtimesTheaterDistance)}>{distance + distanceUnit}</span>
						<span class={joinClasses(s.address, fontStyles.showtimesTheaterAddress)}>{`${theaterStreet}, ${theaterCity}`}</span>
					</div>
				</div>
			</div>
		);
	}

	render(props) {
		let { theater, loading } = props;
		let hasMessage = !(loading || theater.loading) && (theater.error || !theater.screenings || !theater.screenings.length);
		return (
			<div
				class={joinClasses({
					s,
					container: true,
					animateExpansion: props.animateExpansion,
					hasMessage
				}, s[props.mode], this.props.class)}
			>
				{this.renderHeader()}
				{this.renderDateScroller()}
				{this.renderViewButtonState()}
				{this.renderVisualState()}
			</div>
		);
	}
}
